export var paginationLocale = {
  ellipsis: '…',
  previous: 'Previous',
  next: 'Next',
  ariaLabel: 'Pagination',
  ariaGoToPrevious: 'Previous page',
  ariaGoToNext: 'Next page',
  ariaCurrentPage: function ariaCurrentPage(page) {
    return "Page ".concat(page, ", current page");
  },
  ariaGoToPage: function ariaGoToPage(page) {
    return "Page ".concat(page);
  }
};